/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
export const gmaoInputTelComponent = {
    template: require('./gmao-input-tel.html'),
    bindings: {
        model: '=',
        modelOptions: '<',
        validationError: '<',
        disabled: '<',
        readonly: '<',
        required: '<',
        maxLength: '<',
        placeholderKey: '<',
        hintKey: '<'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoInputTel.js